import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "BluetoothOff"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 19.9425L4.0575 3.00004L3 4.05754L10.9425 12L5.25 17.6925L6.3075 18.75L11.25 13.8075V21.75C11.2493 22.043 11.4192 22.3095 11.685 22.4325C11.7843 22.4763 11.8915 22.4993 12 22.5C12.1788 22.5001 12.3516 22.4362 12.4875 22.32L17.2125 18.27L19.9425 21L21 19.9425ZM12.75 20.1226V13.8076L16.1475 17.2051L12.75 20.1226ZM12.75 9.56254V3.87754L16.1475 6.79504L13.065 9.87754L14.1225 10.935L17.7825 7.28254C17.9229 7.141 18.0012 6.9494 18 6.75004C17.9915 6.54134 17.8964 6.34564 17.7375 6.21004L12.4875 1.71004C12.265 1.51882 11.9515 1.47487 11.685 1.59754C11.4288 1.71588 11.2607 1.96802 11.25 2.25004V8.06254L12.75 9.56254Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/BluetoothOff.vue"]]);
